import firebase from 'firebase/app';
import 'firebase/firestore';

export default class FireStore {
	static async fetchExamQuestions(subjectId) {
		const subjectRef = firebase.firestore().collection('subjects').doc(subjectId);

		const subjectSnapshot = await subjectRef.get();

		if (!subjectSnapshot.exists) return [];

		const numberOfChapters = subjectSnapshot.data().numberOfChapters;

		let chaptersSnapshots = [];

		for (let index = 0; index < numberOfChapters; index++) {
			const chapterRef = subjectRef.collection('chapters').doc(index.toString());
			chaptersSnapshots.push(chapterRef.get());
		}

		const numberOfQuestionsInChapters = (await Promise.all(chaptersSnapshots)).map(
			chapterSnapshot => chapterSnapshot.data().numberOfQuestions
		);

		const totalNumberOfQuestions = numberOfQuestionsInChapters.reduce(
			(accumulator, currentValue) => accumulator + currentValue
		);

		let acc = 0;
		let numberOfQuestionsToFetchFromEachChapters = [];

		for (let index = 0; index < numberOfChapters; index++) {
			let numberOfChapterQuestions = Math.floor(
				numberOfQuestionsInChapters[index] * (60 / totalNumberOfQuestions)
			);

			numberOfQuestionsToFetchFromEachChapters.push(numberOfChapterQuestions);
			acc += numberOfChapterQuestions;
		}

		for (let index = numberOfChapters - 1; index >= 0; index--) {
			const margin = 60 - acc;
			let numberOfChapterQuestions = numberOfQuestionsToFetchFromEachChapters[index];

			if (numberOfChapterQuestions + margin <= numberOfQuestionsInChapters[index]) {
				numberOfQuestionsToFetchFromEachChapters[index] =
					numberOfQuestionsToFetchFromEachChapters[index] + margin;
				break;
			}
		}

		const questionNumbersForEachChapter = numberOfQuestionsToFetchFromEachChapters.map(
			(element, index) =>
				generateRandomQuestionNumbers(element, numberOfQuestionsInChapters[index] - 1)
		);
		
		let chaptersQuestionsPromises = [];

		for (let index = 0; index < questionNumbersForEachChapter.length; index++) {
			const questionNumbersForChapter = questionNumbersForEachChapter[index];
			const chapterRef = subjectRef.collection('chapters').doc(index.toString());
			const chapterQuestionsPromises = questionNumbersForChapter.map(element => 
				chapterRef.collection('questions').doc(stringifyNumber(element)).get()
			);

			chaptersQuestionsPromises = [...chaptersQuestionsPromises, ...chapterQuestionsPromises];
		}

		let allQuestions = (await Promise.all(chaptersQuestionsPromises)).map(
			questionSnapshot => questionSnapshot.data()
		);

		return allQuestions;
	}

	static async fetchChapterQuestions(subjectId, chapterID) {
		const chapterRef = firebase
			.firestore()
			.collection('subjects')
			.doc(subjectId)
			.collection('chapters')
			.doc(chapterID)
			.collection('questions');

		const snapshot = await chapterRef.get();

		const questions = snapshot.docs.map(doc => doc.data());
		return questions;
	}

	static async incrementNumberOfUserSessions(uid, chapterId, subjectId) {
		const userRef = firebase.firestore().collection('users').doc(uid);
		const userChapterRef = userRef.collection(subjectId).doc(chapterId);
		const [user, userChapter] = await Promise.all([userRef.get(), userChapterRef.get()]);
		const increment = firebase.firestore.FieldValue.increment(1);

		if (user.exists) userRef.update({ numberOFSessions: increment });
		else userRef.set({ numberOFSessions: increment });

		if (userChapter.exists) userChapterRef.update({ numberOFSessions: increment });
		else userChapterRef.set({ numberOFSessions: increment });
	}
}

const generateRandomQuestionNumbers = (numberOfQuestions, maxValue) => {
	let randomQuestionNumbers = [];
	while (randomQuestionNumbers.length < numberOfQuestions) {
		const randomNumber = randomInteger(0, maxValue);
		if (randomQuestionNumbers.includes(randomNumber)) continue;
		randomQuestionNumbers.push(randomNumber);
	}
	return randomQuestionNumbers;
};

const randomInteger = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const stringifyNumber = number => {
	let stringNumber = String(number);
	return (
		Array(4 - stringNumber.length)
			.fill('0')
			.join('') + number
	);
};